//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { rando } from '@nastyox/rando.js'

export default {
  mounted () {
    this.tl = gsap.timeline({
      onComplete: (...args) => {
        this.$emit('complete', ...args)
      }
    })

    this.tl.set(['#controls', '#heart', '#like', '#eye', '#cover-hack'], { opacity: 0 })
    this.tl.set(['#heart', '#like', '#eye'], { transformOrigin: '50% 50%', scale: 0.5, rotate: () => rando(-50, 50) + 'deg' })

    this.tl
      .from('#root', { opacity: 0, duration: 0.5 })
      .to('#cover', { y: '-=580', duration: 2, ease: 'expo.in' })
      // .to('#cover-hack', { opacity: 1, duration: 10.1 }, '<')
      .to('#cover', { opacity: 0, duration: 1, ease: 'expo.in' }, '<1')
      // .to('#cover-hack', { opacity: 0, duration: 0.3 }, '<')
      .to(['#heart', '#like', '#eye'], { scale: 1, opacity: 1, rotate: '0deg',  ease: 'expo.out' })
      .to(['#controls'], { opacity: 1 }, '<')
  }
}
